/* NOVU STUDIO theme JS */
(function () {
  // Transparent-over-hero nav that turns solid on scroll
  var nav = document.querySelector('.site-nav');
  var hero = document.querySelector('.hero');
  if (nav && hero && !nav.classList.contains('site-nav--solid')) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        nav.classList.toggle('scrolled', !entries[0].isIntersecting);
      }, { threshold: 0.1 }).observe(hero);
    } else {
      nav.classList.add('scrolled');
    }
  }

  // Product variant selection -> price, availability, hidden id
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = form.querySelector('[data-variants-json]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var stockEl = document.querySelector('[data-stock]');
    var btn = form.querySelector('[data-add-btn]');
    var money = function (cents) {
      var fmt = form.getAttribute('data-money-format') || '£{{amount}}';
      var amount = (cents / 100).toFixed(2);
      if (fmt.indexOf('no_decimals') > -1) amount = Math.round(cents / 100).toString();
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    };
    var lowStock = parseInt(form.getAttribute('data-low-stock') || '3', 10);

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function update() {
      var opts = selectedOptions();
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!v) {
        btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable-text');
        return;
      }
      idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = money(v.price) + (v.compare_at_price && v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
      }
      if (v.available) {
        btn.disabled = false; btn.textContent = btn.getAttribute('data-add-text');
        if (stockEl) {
          if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= lowStock) {
            stockEl.textContent = v.inventory_quantity === 1 ? 'last pair' : 'only ' + v.inventory_quantity + ' left';
            stockEl.classList.add('product-stock--low');
          } else { stockEl.textContent = ''; stockEl.classList.remove('product-stock--low'); }
        }
      } else {
        btn.disabled = true; btn.textContent = btn.getAttribute('data-soldout-text');
        if (stockEl) { stockEl.textContent = ''; }
      }
      if (history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    form.querySelectorAll('[data-option-index] input').forEach(function (i) { i.addEventListener('change', update); });
    update();
  });

  // Cart quantity +/- buttons (submit the cart form on change)
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelector('[data-minus]').addEventListener('click', function () {
      input.value = Math.max(0, parseInt(input.value || '0', 10) - 1); input.form.submit();
    });
    wrap.querySelector('[data-plus]').addEventListener('click', function () {
      input.value = parseInt(input.value || '0', 10) + 1; input.form.submit();
    });
    input.addEventListener('change', function () { input.form.submit(); });
  });

  // Product image slideshow
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var track = root.querySelector('[data-pm-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pm-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pm-dot]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pm-thumb]'));
    var prevBtn = root.querySelector('[data-pm-prev]');
    var nextBtn = root.querySelector('[data-pm-next]');
    if (!track || slides.length < 2) return;
    var index = 0;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === index); });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-index'), 10)); }); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10)); }); });

    // Swipe support
    var startX = null;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) goTo(dx < 0 ? index + 1 : index - 1);
      startX = null;
    });

    // Keyboard arrows when the slideshow has focus
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') goTo(index - 1);
      if (e.key === 'ArrowRight') goTo(index + 1);
    });
  });
})();
